// extracted by mini-css-extract-plugin
export default {"overlay":"overlay-2o7K5","closeButton":"closeButton-3fFv6","tootipbox":"tootipbox-2Bk8I"};